"use strict";

import angular from "angular";

import _ from "lodash";

export class StepsControl {
    constructor() {
        this.steps = [];
        this.step = 0;
    }

    /**
     * @interface StepInterface
     * @prop {string} name - Titulo do step
     * @prop {Number} position - Posição do step
     * @prop {function} onClick - Função para inicializar uma função
     *
     * @param {Array<StepInterface>} steps
     * @param {Number} stepIndex
     *
     * @returns {Object}
     */
    initSteps(steps, stepIndex = 0) {
        if (this.steps.length) return;
        this.steps = steps;
        this.step = stepIndex;
    }

    /**
     *
     * @param {Number} stepIndex - Posição do step
     */
    setStep(stepIndex) {
        this.step = stepIndex;
    }

    setOnClick(method, stepIndex) {
        if (_.get(this.steps, `[${stepIndex}]`))
            this.steps[stepIndex].onClick = method;
    }

    hideStep(stepIndex) {
        if (_.get(this.steps, `[${stepIndex}]`))
            this.steps[stepIndex].hide = true;
    }

    showStep(stepIndex) {
        if (_.get(this.steps, `[${stepIndex}]`))
            this.steps[stepIndex].hide = false;
    }

    setPosition(stepIndex, position) {
        if (_.get(this.steps, `[${stepIndex}].position`) > -1)
            this.steps[stepIndex].position = position;
    }

    clearSteps() {
        this.steps = [];
    }

    setStepName(name, stepIndex) {
        if (!this.steps[stepIndex]) return;
        this.steps[stepIndex].name = name;
    }
}

angular.module("nucont.shared").service("StepsControl", [StepsControl]);
